export default class Dropdown {
  constructor () {
    this.el = '.js-dropdown'
    this.toggler = '.js-dropdown-toggler'
    this.activeEl = null

    this.init()
  }

  init () {
    this.initEvents()
  }

  initEvents () {
    $(document).on('click', this.toggler, e => this.toggle(e))
    $(document).on('click', e => this.onClickOut(e))
  }

  toggle (e) {
    const $target = $(e.currentTarget)
    const $dropdown = $target.parents(this.el)
    if ($dropdown.hasClass('open')) {
      $dropdown.removeClass('open')
      this.activeEl = $dropdown
      return
    }
    $(this.el).removeClass('open')
    $dropdown.addClass('open')
    this.activeEl = null
  }

  onClickOut (e) {
    if ( !$(this.el).is(e.target) && $(this.el).has(e.target).length === 0 ) {
      $(this.el).removeClass('open')
      this.activeEl = null
      $('.header').removeClass('tel-open')
    }
  }
}
